import { ReactComponent as CommunicationImage } from "assets/icons/communicationSuccessImage.svg";
import React from "react";
import { Footer } from "../Footer/Footer";
import {
  CommunicationImageWrapper,
  SummaryDetails,
  Text,
  Title,
  Wrapper,
} from "./Theme";
export const CreatedAutomationDone = ({
  details,
  text,
  setCampaignModal,
  refresh,
  setRefresh
}) => {
  

  const buttons = [
    {
      name: "Done",
      action: () => {
        setCampaignModal();
        setRefresh(!refresh)
      },
      isDisabled: false,
      type: "primary",
      width: "100px",
      variant : "primary"
    },
  ];
  return (
    <Wrapper>
      <CommunicationImageWrapper>
        <CommunicationImage />
      </CommunicationImageWrapper>
      <Title>
        <Text>{text}</Text>
      </Title>
      {/* <SummaryDetails>
        <ul>
          {details?.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </SummaryDetails> */}
      <hr />
      <br />
      <Footer
            buttons={buttons}
            Wrapperstyle={{
              width: "78%",
              position: 'absolute',
              bottom: '34px',
            }}
            type="My template"
          />
    </Wrapper>
  );
};
